module.exports = __webpack_public_path__ + "media/components/slider/s7-95bb7a2d603d2936d4165fd96fedd8ef.jpg";